import React, { useState } from "react";
import BackButton from "../../components/BackButton/BackButton";
import Button from "../../components/Button/Button";
import Header from "../../components/Header/Header";
import TextInput from "../../components/TextInput/TextInput";
import { emailValidator } from "../../helpers/emailValidator";
import { passwordValidator } from "../../helpers/passwordValidator";
import RegisterScreenNext from "./RegisterScreenNext";

const RegisterScreen = () => {
	const [email, setEmail] = useState({ value: "", error: "" });
	const [password, setPassword] = useState({ value: "", error: "" });
	const [allowNext, setAllowNext] = useState(false);

	/**
	 * Main Functions
	 */
	const handleNext = () => {
		const emailError = emailValidator(email.value);
		const passwordError = passwordValidator(password.value);
		if (emailError || passwordError) {
			setEmail({ ...email, error: emailError });
			setPassword({ ...password, error: passwordError });
			return;
		}
		setAllowNext(true);
	};
	/** **/

	return allowNext ? (
		<RegisterScreenNext
			email={email.value}
			password={password.value}
			allowStep2={setAllowNext}
		/>
	) : (
		<div className="RegisterScreen h-full w-full m-0 p-3 py-8 flex flex-col items-center">
			<BackButton target={"/"} className="mr-auto" />
			<Header className={"my-8 mr-auto"} size={"large"}>
				Register
			</Header>
			<TextInput
				className={"my-2"}
				type={"text"}
				name={"email"}
				id={"email"}
				placeholder={"Email"}
				value={email.value}
				onChange={(e) => {
					setEmail({ value: e.target.value, error: "" });
				}}
				error={email.error !== ""}
				errorMessage={email.error}
			/>
			<TextInput
				className={"my-2"}
				type={"password"}
				name={"password"}
				id={"password"}
				placeholder={"Password"}
				value={password.value}
				onChange={(e) => {
					setPassword({ value: e.target.value, error: "" });
				}}
				error={password.error !== ""}
				errorMessage={password.error}
			/>
			<Button
				className={"my-2"}
				title={"NEXT"}
				mode={"filled"}
				size={"full"}
				onClick={(e) => handleNext()}
			/>
		</div>
	);
};

export default RegisterScreen;
